__turbopack_context__.v({
  "className": "inter_97862f09-module__llcmBa__className",
});
